import { AfterViewInit, Component, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'instruction-mfo',
  templateUrl: './instruction-mfo.component.html',
})
export class InstructionMFOComponent implements OnInit, OnChanges {
  @Input() currentUser;
  @Input() setupInstructions = [];
  @Input() title = [];
  @Input() hasCustomTitle = false;
  @Input() videoSrc: string = '';
  iframeSrc: SafeResourceUrl;
  private sanitizer = inject(DomSanitizer);

  constructor() {
    // Remove hardcoded iframeSrc - it will be set via ngOnChanges
  }

  ngOnInit(): void {
    // Set initial video if provided
    if (this.videoSrc) {
      this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoSrc);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { videoSrc } = changes;
    if (videoSrc?.currentValue && videoSrc?.currentValue !== videoSrc?.previousValue) {
      this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(videoSrc?.currentValue);
    }
  }

  updateIframeSrc(newUrl: string) {
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(newUrl);
  }
}
